import * as React from "react";
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import Licence from "./Licence";
import rootPath, { RouteProps, licence as licencePath } from "./routes-path";

interface UpajeOpProps {
    clenId: number;
}

class UpajeOp extends React.PureComponent<UpajeOpProps & RouteComponentProps<RouteProps>> {

    render() {
        const { match, clenId } = this.props;
        const { idtClena, lang } = match.params;

        const getPath = (p: string) => (`${match.url}${p}`);


        return <Switch>
            <Route path={rootPath} exact render={() => <Licence idtClena={Number(idtClena)} clenId={clenId} />} />


            <Redirect to={rootPath} />
        </Switch>
    }
}

export default withRouter(UpajeOp);